// import comet from '../../../../static/images/browse/comet.svg';
// import shadow from '../../../../static/images/browse/nightlife_shadow.svg';
import './NightlifeBackground.scss';

import React from 'react';

// const Comet: React.FC<{
//     top: string;
//     right?: string;
//     left?: string;
// }> = ({ top, right, left }) => {
//     const styles: React.CSSProperties = {
//         top,
//     };

//     if (right) {
//         styles.right = right;
//     } else if (left) {
//         styles.left = left;
//     }

//     return (
//         <div className="rectangle-container" style={styles}>
//             <img className="comet" src={comet} alt="comet"></img>
//         </div>
//     );
// };

export const NightlifeBackground = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    return (
        <div className="nightlife_background">
            {/* <img className="shadow1" src={shadow} alt="Shadow Image 1"></img>
            <img className="shadow2" src={shadow} alt="Shadow Image 2"></img>
            <img className="shadow3" src={shadow} alt="Shadow Image 3"></img>
            <img className="shadow4" src={shadow} alt="Shadow Image 4"></img>
            <img className="shadow5" src={shadow} alt="Shadow Image 5"></img>
            <Comet top="-500px" right="-250px" />
            <Comet top="-350px" right="-200px" />
            <Comet top="-300px" right="0px" />
            <Comet top="50px" left="350px" />
            <Comet top="1200px" left="1250px" />
            <Comet top="1500px" left="1200px" />
            <Comet top="1200px" left="250px" />
            <Comet top="1600px" left="1050px" />
            <Comet top="2400px" left="-250px" /> */}

            {children}
        </div>
    );
};
